export const tr = {
    'audip-genres-title': 'Türler'
};
